import { render, staticRenderFns } from "./ForJournalists.vue?vue&type=template&id=71f04b6e"
import script from "./ForJournalists.vue?vue&type=script&lang=js"
export * from "./ForJournalists.vue?vue&type=script&lang=js"
import style0 from "./ForJournalists.vue?vue&type=style&index=0&id=71f04b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports